import { api } from "@/api/base";

export async function fetchTranslationsForLanguage(language: string): Promise<object> {
  return api.get(`translations/v2/recruitments/${language}`).json();
}
